import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const MachineSearchParamsSchema = z
  .object({
    q: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type MachineSearchParams = z.infer<typeof MachineSearchParamsSchema>

export const MachineSearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  group: z.string(),
  runningPrefix: z.string(),
  testingPrefix: z.string(),
  capacityPerHour: z.number(),
})

export type MachineSearchResultModel = z.infer<
  typeof MachineSearchResultModelSchema
>

export const MachineSearchResultSchema = z
  .object({
    data: z.array(MachineSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type MachineSearchResult = z.infer<typeof MachineSearchResultSchema>
